<template>
  <div class="text-center">
    <h1 class="u-xxl">😲h, snap!</h1>
    <small class="grey--text mb-3">404: Page Not Found</small>
    <h1 class="font-weight-bold">We could not find the page you requested.</h1>
    <router-link to="/" style="text-decoration: none">
      <v-btn depressed outlined class="mt-12 sokoPrimary--text" rounded>
        <v-icon left dark>mdi-home</v-icon>Go back home
      </v-btn>
      <!-- <h2>
        <v-icon>mdi-home</v-icon>
        <span></span>
      </h2>-->
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Error",
};
</script>

<style>
.u-xxl {
  font-size: 7rem;
}
</style>
